document.addEventListener('DOMContentLoaded',()=>{
  const button=document.querySelector('[data-back-to-top]');
  if(button){
    const update=()=>button.classList.toggle('visible',window.scrollY>500);
    window.addEventListener('scroll',update,{passive:true});
    update();
    button.addEventListener('click',()=>window.scrollTo({top:0,behavior:'smooth'}));
  }

  const headerCategories=document.querySelector('[data-header-categories]');
  const headerCategoryToggle=document.querySelector('[data-header-category-toggle]');
  if(headerCategories&&headerCategoryToggle){
    let leaveTimer,suppressFocus=false;
    const setOpen=open=>{clearTimeout(leaveTimer);headerCategories.classList.toggle('is-open',open);headerCategoryToggle.setAttribute('aria-expanded',String(open));};
    headerCategoryToggle.addEventListener('click',event=>{event.preventDefault();event.stopPropagation();setOpen(!headerCategories.classList.contains('is-open'));});
    headerCategories.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse')setOpen(true);});
    headerCategories.addEventListener('pointerleave',event=>{if(event.pointerType==='mouse')leaveTimer=setTimeout(()=>{if(!headerCategories.contains(document.activeElement))setOpen(false);},250);});
    headerCategories.addEventListener('focusin',event=>{if(!suppressFocus&&event.target!==headerCategoryToggle)setOpen(true);});
    headerCategories.addEventListener('focusout',event=>{if(!headerCategories.contains(event.relatedTarget))setOpen(false);});
    document.addEventListener('click',event=>{if(!headerCategories.contains(event.target))setOpen(false);});
    document.addEventListener('keydown',event=>{if(event.key==='Escape'&&headerCategories.classList.contains('is-open')){setOpen(false);suppressFocus=true;headerCategoryToggle.focus();suppressFocus=false;}});
  }

  document.querySelectorAll('[data-header-department]').forEach(department=>{
    const button=department.querySelector('[data-subcategory-toggle]');
    const panel=department.querySelector('[data-header-subcategories]');
    let timer,suppressFocus=false;
    const setOpen=open=>{clearTimeout(timer);panel.hidden=!open;button.setAttribute('aria-expanded',String(open));};
    department.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'&&matchMedia('(min-width:951px)').matches)setOpen(true);});
    department.addEventListener('pointerleave',event=>{if(event.pointerType==='mouse')timer=setTimeout(()=>{if(!department.contains(document.activeElement))setOpen(false);},180);});
    department.addEventListener('focusin',event=>{if(!suppressFocus&&event.target!==button)setOpen(true);});
    department.addEventListener('focusout',event=>{if(!department.contains(event.relatedTarget))setOpen(false);});
    button.addEventListener('click',event=>{event.stopPropagation();setOpen(panel.hidden);});
    department.addEventListener('keydown',event=>{if(event.key==='Escape'&&!panel.hidden){event.stopPropagation();setOpen(false);suppressFocus=true;button.focus();suppressFocus=false;}});
    document.addEventListener('click',event=>{if(!department.contains(event.target))setOpen(false);});
  });

  const categoryPage=document.querySelector('.categories-page');
  const departmentLinks=[...document.querySelectorAll('[data-category-department-link]')];
  const categoryFamilies=[...document.querySelectorAll('[data-category-family]')];

  if(categoryPage&&departmentLinks.length&&categoryFamilies.length){
    const showDepartment=(target,scroll)=>{
      const selected=categoryFamilies.find((family)=>family.id===target)||categoryFamilies[0];
      categoryFamilies.forEach((family)=>{family.hidden=family!==selected;});
      departmentLinks.forEach((link)=>{const active=link.dataset.categoryTarget===selected.id;link.classList.toggle('is-selected',active);if(active)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current');});
      if(selected&&scroll)selected.scrollIntoView({behavior:'smooth',block:'start'});
    };

    departmentLinks.forEach((link)=>{
      link.addEventListener('click',(event)=>{
        event.preventDefault();
        const target=link.dataset.categoryTarget;
        history.pushState(null,'',`#${target}`);
        showDepartment(target,false);
      });
    });

    const showFromHash=()=>{
      const target=window.location.hash.slice(1);
      showDepartment(target,false);
    };

    window.addEventListener('hashchange',showFromHash);
    showFromHash();
  }
});

document.addEventListener('DOMContentLoaded',()=>document.querySelectorAll('[data-catalog-gallery]').forEach(gallery=>{
 const main=gallery.querySelector('.catalog-main-image img');
 gallery.querySelectorAll('[data-gallery-image]').forEach(button=>button.addEventListener('click',()=>{
  if(!main)return;main.removeAttribute('srcset');main.src=button.dataset.galleryImage;main.alt=button.dataset.galleryAlt;
  gallery.querySelectorAll('[data-gallery-image]').forEach(other=>other.setAttribute('aria-pressed',String(other===button)));
 }));
}));
document.addEventListener('DOMContentLoaded',()=>document.querySelectorAll('.catalog-product-details').forEach(host=>{
 const panels=[...host.querySelectorAll(':scope > details')];if(!panels.length)return;
 const list=document.createElement('div');list.className='catalog-detail-tabs';list.setAttribute('role','tablist');list.setAttribute('aria-label','Product information');
 const buttons=panels.map((panel,index)=>{const summary=panel.querySelector('summary'),button=document.createElement('button');button.type='button';button.id=`catalog-detail-tab-${index}`;panel.id=`catalog-detail-panel-${index}`;button.textContent=summary.textContent;button.setAttribute('role','tab');button.setAttribute('aria-controls',panel.id);panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',button.id);panel.open=true;summary.hidden=true;list.appendChild(button);return button;});
 const activate=index=>panels.forEach((panel,i)=>{panel.hidden=i!==index;buttons[i].setAttribute('aria-selected',String(i===index));buttons[i].tabIndex=i===index?0:-1;});
 buttons.forEach((button,index)=>{button.addEventListener('click',()=>activate(index));button.addEventListener('keydown',event=>{let next;if(event.key==='ArrowRight')next=(index+1)%buttons.length;else if(event.key==='ArrowLeft')next=(index+buttons.length-1)%buttons.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=buttons.length-1;else return;event.preventDefault();activate(next);buttons[next].focus();});});host.prepend(list);activate(0);
}));
